import { useEffect } from "react";
function useOnHorizontalVisibilityChange(target, callback) {
  const visible = target ? target.scrollWidth > target.clientWidth : false;
  useEffect(() => {
    callback?.(visible);
  }, [visible, callback]);
}
export {
  useOnHorizontalVisibilityChange
};
//# sourceMappingURL=useOnHorizontalVisibilityChange.js.map
